// extracted by mini-css-extract-plugin
module.exports = {"dropDown":"UserMenu__dropDown","avatar":"UserMenu__avatar","dropDownToggle":"UserMenu__dropDownToggle","dropDownList":"UserMenu__dropDownList"};